// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ywPT9","questions":"styles_questions__2xJ4_","footer":"styles_footer__2g_EO"};